(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ymj-thought-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ymj-quiz]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = root.querySelector('form');
    const steps = Array.from(root.querySelectorAll('[data-quiz-step]'));
    const nextButton = root.querySelector('[data-quiz-next]');
    const backButton = root.querySelector('[data-quiz-back]');
    const actions = root.querySelector('[data-quiz-actions]');
    const progress = root.querySelector('.ymj-quiz__progress');
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const progressBar = root.querySelector('[data-quiz-progress-bar]');
    const result = root.querySelector('[data-quiz-result]');
    let current = 1;

    const showStep = (number) => {
      current = number;
      steps.forEach((step) => {
        step.hidden = Number(step.dataset.quizStep) !== current;
      });
      result.hidden = true;
      progress.hidden = current === 6;
      actions.hidden = current === 6;
      if (current <= 5) {
        progressLabel.textContent = `Question ${current} of 5`;
        progressBar.style.width = `${current * 20}%`;
        backButton.hidden = current === 1;
        nextButton.textContent = current === 5 ? 'See my result' : 'Next';
        nextButton.disabled = !form.querySelector(`input[name="q${current}"]:checked`);
      }
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) nextButton.disabled = false;
    });

    nextButton.addEventListener('click', () => {
      if (current < 5) showStep(current + 1);
      else showStep(6);
    });

    backButton.addEventListener('click', () => {
      if (current > 1) showStep(current - 1);
    });

    form.addEventListener('submit', () => {
      if (!form.reportValidity()) return;

      const counts = { a: 0, b: 0, c: 0 };
      for (let index = 1; index <= 5; index += 1) {
        const answer = form.querySelector(`input[name="q${index}"]:checked`);
        if (answer) counts[answer.value] += 1;
      }

      const highest = Math.max(counts.a, counts.b, counts.c);
      const winners = Object.keys(counts).filter((key) => counts[key] === highest);
      const key = winners.length === 1 ? winners[0] : 'mixed';
      const tags = form.querySelector('[data-quiz-tags]');
      const submitButton = form.querySelector('.ymj-quiz__submit');
      tags.value = `newsletter, thought-spiral-quiz, quiz-result-${key}`;
      submitButton.disabled = true;
      submitButton.textContent = 'SENDING...';
    });

    document.querySelectorAll('a[href="#ymj-spiral-form"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    showStep(1);
  });

  } catch(e) { console.error(e); }
})();
})();
